import { React, Route, Routes, ts, ui } from '_core';

import BrowserList from './browser-list';
import Form from './form';
import SingleAnalysis from './single-analysis';
import { DraftParams, Params } from './types';

type BrowserProps = {
  mode: ts.enums.CHART_MODE_ENUM;
  context: ts.types.signalSet.SignalSetAnalysisContext;
  jobId: number;
  params: DraftParams;
  setParams: (_p: DraftParams) => void;
  jobCreatedAt?: string;
};

const Browser = ({ context, jobId, params, setParams, mode, jobCreatedAt }: BrowserProps) => {
  const signals = React.useMemo(() => context.signals, [context]);
  const startDate = React.useMemo(() => context.start_date, [context]);
  const endDate = React.useMemo(() => context.end_date, [context]);

  const chart = () => (
    <BrowserList
      signalsMetadata={signals}
      params={params as Params}
      setParams={setParams}
      startDate={startDate}
      endDate={endDate}
      jobCreatedAt={jobCreatedAt}
    />
  );

  if (mode == 'edit') return <Form params={params} setParams={setParams} />;
  return (
    <Routes>
      <Route path="single/:signalId">
        <Route
          index
          path="*"
          element={
            <ui.RenderByRouteParam
              component={({ signalId }: { signalId: string }) => {
                const signal = signals.find((s) => s.id.toString() === signalId);
                if (!signal) return null;

                return (
                  <SingleAnalysis
                    key={signal.id + jobId}
                    signalMetadata={signal}
                    defaultId={params.report_default_id}
                    startDate={startDate}
                    endDate={endDate}
                    jobId={jobId}
                  />
                );
              }}
            />
          }
        />
      </Route>
      <Route path="*" element={chart()} />
    </Routes>
  );
};

export default Browser;
